"use strict";

$(document).ready(function () {
  var homepage = new HomepageController();
});